
<template>
  <div class="content">
    <el-row style="width: 94%;
    padding-top: 3%;
    margin-left: 3%;
    background-color: white;
    text-align: left;
    font-family: Calibri;
    padding-bottom:200px;">
      <el-col>
        <el-row style="padding-top: 15px;">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          For the production of the current global road length data, the current global road spatial distribution pattern was taken as the basis, and the global road length data with administrative regions as the basic statistical unit is distributed to the spatial grid, so as to realize the spatialization of global roads and obtain the global road spatial distribution data of 0.5 ° grid.
          <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          For the future global road network distribution, this study mainly estimated it based on the land coefficient theory.The land coefficient method is based on the land coefficient theory that "the road length is directly proportional to the square root of population and area and its economic index coefficient", and uses the area, population and economic level indicators of the area where the road network is located to calculate the reasonable theoretical road length in the area [2]. The calculation formula is as follows:
        </el-row>
        <el-row style="text-align: center;">
          <img src="http://bunjs.aiside.top/6-1.png"/>
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Where, <span style="font-style: italic;font-weight: bold;">K</span> is road network coefficient / economic coefficient;  <span style="font-style: italic;font-weight: bold;">P</span> is population (unit: 10000 people);
          <span style="font-style: italic;font-weight: bold;">A</span> is area (unit: 100km2);  <span style="font-style: italic;font-weight: bold;">L</span> is road length.
        </el-row>

        <el-row>
          <br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The economic coefficient, population and area involved in the model directly reflect the three most important aspects affecting the road scale, which has strong practicability, and the projection results can truly reflect the actual demand of the projection area. Among the three parameters, the economic coefficient K is calculated as follows.
        </el-row>

        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Firstly, according to the following formula, the data of road length (<span style="font-style: italic;font-weight: bold">L<span style="vertical-align: sub;">n</span></span>),
          population (<span style="font-style: italic;font-weight: bold">P<span style="vertical-align: sub;">n</span></span>) and area (<span style="font-style: italic;font-weight: bold">A<span style="vertical-align: sub;">n</span></span>)
          over the years were used to calculated the economic coefficient <span style="font-style: italic;font-weight: bold">K<span style="vertical-align: sub;">n</span></span> over the years，
        </el-row>
        <el-row style="text-align: center;">
          <img src="http://bunjs.aiside.top/6-2.png"/>
        </el-row>

        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Using the per capita GDP data (<span style="font-style: italic;font-weight: bold">G<span style="vertical-align: sub;">n</span></span>) and calculated <span style="font-style: italic;font-weight: bold">K<span style="vertical-align: sub;">n</span></span> over the years, the relationship between them is obtained through mathematical statistical regression:
        </el-row>
        <el-row style="text-align: center;">
          <img src="http://bunjs.aiside.top/6-3.png"/>
        </el-row>

        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Where: <span style="font-weight: bold;font-style: italic">a</span> and <span style="font-weight: bold;font-style: italic;">b</span> are regression coefficients.
        </el-row>
        <el-row style="text-align: center;">
          <img src="http://bunjs.aiside.top/6-4.png"/>
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          In the future (2030, 2050) production process of global road length under different shared socio-economic paths (ssp1, SSP2, ssp3), based on the land coefficient theory, we used the historical data of road length, population, per capita GDP (economic coefficient K) and land (regional) area to simulate the relationship between road length and socio-economic factors. Combined with different shared socio-economic paths (SSPs) in the future, the global road length data in 2030 and 2050 are obtained.
        </el-row>




      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "GlobalRoadNetwork"
  }
</script>

<style scoped>

  .r_title{
    font-weight: bold;
    font-size: 2.5rem;
  }
  .content{
    overflow-y: scroll;
    line-height: 40px;
    font-size: 2.2rem;
    color: black;
  }
  .content::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/GlobalRoadNetwork.vue